import { CircularProgress } from "@mui/material";
import "./spinner.css";

interface IProps {
  loading: boolean;
  className?: string;
}

const Spinner = ({ loading }: IProps) => {
  return loading ? (
    <div className="ibm__spinner_container">
      <CircularProgress size={50} thickness={2} aria-label="Loading" />
    </div>
  ) : null;
};

export default Spinner;
